import { render, staticRenderFns } from "./_PrivacyPolicy.vue?vue&type=template&id=539f559a"
import script from "./_PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./_PrivacyPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports